import { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../sidebar/sidebar";
import SearchWithAPI from "../../common/searchbox/searchBox2.js";
import ReactPaginate from "react-paginate";
import TopBar from "../../topbar/TopBar";
import search from "../../../assets/svg/search.svg";
import df from "../../../assets/svg/df.svg";
import cus from "../../../assets/svg/cus.svg";
import filt from "../../../assets/svg/filt.svg";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import pn from "../../../assets/svg/pn.svg";
import { get } from "../../../services/apiService";
import { Container, Row, Col, ToastContainer, Toast } from "react-bootstrap";
import { alertSubmitApi, getalertConfig, getalertConfigApi, getalertDetailsApi } from "./alertConfigure-api.js";

const visitorSteps = ["Visitor gate-in", "Visitor Gate-Out", "Visitor Scheduled", "Visitor Scheduled Update", "Visitor Queue Submit", "Visitor Queue Reject", "Visitor Checklist Fail", "Visitor Checklist Approve", "Visitor Checklist Reject"];

const Alertconfiguration = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const rightRef = useRef(null);
  const [rightHeight, setRightHeight] = useState(0);

  useEffect(() => {
    if (rightRef.current) {
      setRightHeight(rightRef.current.offsetHeight);
    }
  }, []);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [activeTab, setActiveTab] = useState({ label: '', value: '' });
  const [alertConfigList, setalertConfigList] = useState([]);
  const [emailConfig, setEmailConfig] = useState(null);
  const [emailTemp, setEmailTemp] = useState(null);
  const [smsConfig, setSmsConfig] = useState(null);
  const [whatsappConfig, setWhatsappConfig] = useState(null);
  const [pushConfig, setPushConfig] = useState(null);
  const [smsConfigTemp, setSmsTemp] = useState(null);
  const [whatsappConfigTemp, setWhatsappTemp] = useState(null);
  const [pushConfigTemp, setPushTemp] = useState(null);


  const handleEmailConfig = (option) => {
    setEmailConfig(option);
  };

  const handleEmailTemp = (option) => {
    setEmailTemp(option);
  };

  const handleSmsConfig = (option) => {
    setSmsConfig(option);
  };

  const handleSmsTemp = (option) => {
    setSmsTemp(option);
  };

  const handleWhatsappConfig = (option) => {
    setWhatsappConfig(option);
  };

  const handleWhatsappTemp = (option) => {
    setWhatsappTemp(option);
  };

  const handlePushTemp = (option) => {
    setPushTemp(option);
  };


  const [toggles, setToggles] = useState({
    email: false,
    sms: false,
    push: false,
    whatsapp: false,
  });

  const handleToggle = (key) => {
    setToggles((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const getAlertConfig = async () => {
    try {
      const response = await getalertConfigApi();
      console.log("alert Configure");
      console.log(response);
      if (response.success === true && response.suggestionlist?.length > 0) {
        setalertConfigList(response.suggestionlist)
        console.log("alert list");
        console.log(alertConfigList);
        setActiveTab(response.suggestionlist[0]);
        getAlertDetials(response.suggestionlist[0].value);
      }

    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getAlertDetials = async (value) => {
    try {
      const response = await getalertDetailsApi(value);
      console.log("alert Details");
      console.log(response);
      if (response.status === true) {
        // setalertConfigList(response.suggestionlist)

        const alertConfig = response.config;
        setEmailConfig({
          label: alertConfig["email"] ?? "",
          value: alertConfig["email_config_id"] ?? "",
        });
        setEmailTemp({
          label: alertConfig["email_template"] ?? "",
          value: alertConfig["email_template_id"] ?? "",
        });
        setSmsConfig({
          label: alertConfig["sms"] ?? "",
          value: alertConfig["sms_config_id"] ?? "",
        });
        setSmsTemp({
          label: alertConfig["sms_template"] ?? "",
          value: alertConfig["sms_template_id"] ?? "",
        });
        setWhatsappConfig({
          label: alertConfig["whatsapp"] ?? "",
          value: alertConfig["whatsapp_config_id"] ?? "",
        });
        setWhatsappTemp({
          label: alertConfig["whatsapp_template"] ?? "",
          value: alertConfig["whatsapp_template_id"] ?? "",
        });
        setPushTemp({
          label: alertConfig["app_notification"] ?? "",
          value: alertConfig["app_notification_template_id"] ?? "",
        });
        setToggles({
          email: alertConfig['email_enabled'] ?? false,
          sms: alertConfig['sms_enabled'] ?? false,
          push: alertConfig['app_notification_enabled'] ?? false,
          whatsapp: alertConfig['whatsapp_enabled'] ?? false,
        });

      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const submitform = async (value) => {
    const bodydata = {
      "type": activeTab.value,
      "email_enabled": toggles.email,
      "email_config_id": emailConfig.value,
      "email_template_id": emailTemp.value,
      "sms_enabled": toggles.sms,
      "sms_config_id": smsConfig.value,
      "sms_template_id": smsConfigTemp.value,
      "app_notification_enabled": toggles.push,
      "app_notification_template_id":
        pushConfigTemp.value,
      "whatsapp_enabled": toggles.whatsapp,
      "whatsapp_config_id": whatsappConfig.value,
      "whatsapp_template_id":
        whatsappConfigTemp.value,
      "call_enabled": false,
      "call_config_id": "0",
      "call_template_id": "0"
    };
    const response = await alertSubmitApi(bodydata);
    console.log("response");
    console.log(response);

    if (response.status === true) {
      setSnackbarMessage(response.message);
      setSnackbarStatus(response.status);
      handleSnackbarShow();
      getAlertDetials(activeTab.value)

    }
  }
  useEffect(() => {
    getAlertConfig()

  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (rightRef.current) {
        setRightHeight(rightRef.current.offsetHeight);
      }
    });

    if (rightRef.current) {
      resizeObserver.observe(rightRef.current);
    }

    return () => resizeObserver.disconnect(); // cleanup
  }, []);
  return (
    <div style={{ fontFamily: "Epilogue", }}>
      <div>
        <TopBar />
      </div>
      <div style={{ display: "flex", }}>
        <div>
          <Sidebar activeMenu={"Alert Configuration"} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "24px", backgroundColor: "#FFFFFF" }}>
          <Row className="my-4 align-items-center">
            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>

            <Col >
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 13,
                  color: "#8790A1",
                  whiteSpace: "nowrap", // keep text on a single line
                }}
              >
                Set up your organization with these master settings and manage them seamlessly from here.
              </div>
            </Col>

            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>
          </Row>


          <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "stretch", height: "80%" }}>
            <div >
              <div style={{ fontWeight: "700", fontSize: "20px", color: "#172b4d" }}>Alert Configuration ({alertConfigList.length})</div>
              <div>
                <div style={{ display: "flex", alignItems: "center", borderLeft: "1px dashed #626F86" }}>
                  <div style={{ border: "1px dashed #626F86", width: "20px", height: "0px", visibility: "hidden" }}></div>
                  <div style={{ borderRadius: "8px", visibility: "hidden" }}>Visitor gate-in</div>
                </div>
                {alertConfigList.map((value) => (
                  <div key={value.label} style={{ display: "flex", alignItems: "center", borderLeft: "1px dashed #626F86", cursor: "pointer" }} onClick={() => {
                    setActiveTab(value);
                    getAlertDetials(value.value);
                  }}
                  >
                    <div style={{ border: "1px dashed #626F86", width: "20px", height: "0px" }}></div>
                    <div
                      style={{
                        borderRadius: "8px",
                        padding: "10px 8px 10px 12px",
                        backgroundColor: activeTab.label === value.label ? "#F3FFF8" : "",
                        border: activeTab.label === value.label ? "1px dashed #2c8c53" : "",
                        color: activeTab.label === value.label ? "#2c8c53" : "#000",
                        transition: "all 0.2s ease-in-out",
                        width: "100%",
                      }}
                    >
                      {value.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ borderRadius: "16px", padding: "20px 16px 16px 16px", backgroundColor: "#F8F8F8", display: "flex", flexDirection: "column", gap: "12px", width: "75%", height: "90%", }}>
              <div style={{ marginTop: "6px", fontWeight: "700", fontSize: "14px", color: "#2c8c53", textAlign: "center" }}>{activeTab.label.toUpperCase()}</div>

              <div>
                <div style={{ marginBottom: "12px", fontWeight: "600", fontSize: "13px", color: "#8790A1" }}>Configurations</div>

                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>


                  <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "700", fontSize: "16px", color: "#174b4d" }}>Email</div>
                      <div>
                        <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                          <input type="checkbox" checked={toggles.email} onChange={() => handleToggle("email")} style={{ opacity: 0, width: 0, height: 0 }} />
                          <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: toggles.email ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                          <span style={{ position: "absolute", height: "18px", width: "18px", left: toggles.email ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                        </label>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Email</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleEmailConfig} disabled={!toggles.email} apiUrl={apiUrl + "get_email_config"} params={{}} placeholder={"Select"} selectedOption={emailConfig} />
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Template</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleEmailTemp} disabled={!toggles.email} apiUrl={apiUrl + 'email_template/autosuggestion?type=' + activeTab.value + '&medium=email'} params={{}} placeholder={"Select"} selectedOption={emailTemp} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "700", fontSize: "16px", color: "#174b4d" }}>SMS</div>
                      <div>
                        <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                          <input type="checkbox" checked={toggles.sms} onChange={() => handleToggle("sms")} style={{ opacity: 0, width: 0, height: 0 }} />
                          <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: toggles.sms ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                          <span style={{ position: "absolute", height: "18px", width: "18px", left: toggles.sms ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                        </label>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>SMS</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleSmsConfig} disabled={!toggles.sms} apiUrl={apiUrl + "get_sms_config"} params={{}} placeholder={"Select"} selectedOption={smsConfig} />
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Template</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleSmsTemp} disabled={!toggles.sms} apiUrl={apiUrl + 'email_template/autosuggestion?type=' + activeTab.value + '&medium=sms'} params={{}} placeholder={"Select"} selectedOption={smsConfigTemp} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "700", fontSize: "16px", color: "#174b4d" }}>Push Notification</div>
                      <div>
                        <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                          <input type="checkbox" checked={toggles.push} onChange={() => handleToggle("push")} style={{ opacity: 0, width: 0, height: 0 }} />
                          <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: toggles.push ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                          <span style={{ position: "absolute", height: "18px", width: "18px", left: toggles.push ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                        </label>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Template</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handlePushTemp} disabled={!toggles.push} apiUrl={apiUrl + 'email_template/autosuggestion?type=' + activeTab.value + '&medium=app-notification'} params={{}} placeholder={"Select"} selectedOption={pushConfigTemp} />
                        </div>
                      </div>
                    </div>
                  </div>



                  <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "700", fontSize: "16px", color: "#174b4d" }}>Whatsapp</div>
                      <div>
                        <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                          <input type="checkbox" checked={toggles.whatsapp} onChange={() => handleToggle("whatsapp")} style={{ opacity: 0, width: 0, height: 0 }} />
                          <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: toggles.whatsapp ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                          <span style={{ position: "absolute", height: "18px", width: "18px", left: toggles.whatsapp ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                        </label>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Whatsapp</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleWhatsappConfig} disabled={!toggles.whatsapp} apiUrl={apiUrl + "get_whatsapp_config"} params={{}} placeholder={"Select"} selectedOption={whatsappConfig} />
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Template</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleWhatsappTemp} disabled={!toggles.whatsapp} apiUrl={apiUrl + 'email_template/autosuggestion?type=' + activeTab.value + '&medium=whatsapp'} params={{}} placeholder={"Select"} selectedOption={whatsappConfigTemp} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                      onClick={() => submitform()}
                      style={{
                        borderRadius: "100px",
                        border: "1px solid #E5E5E5",
                        padding: "10px 28px",
                        backgroundColor: "#2C8C53",
                        fontWeight: "700",
                        fontSize: "14px",
                        width: "160px",
                        color: "#FFFFFF",
                        cursor: "pointer"
                      }}
                    >
                      Update
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="top-end">
          <Toast
            className="d-inline-block m-1"
            bg={snackbarStatus === true ? "success" : "danger"}
            show={showSnackbar}
            onClose={handleSnackbarClose}
            delay={3000}
            autohide
          >
            <Toast.Body style={{ color: "#ffffff" }}>
              {snackbarMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div >
  );
};

export default Alertconfiguration;
